import { createContext, useCallback, useContext, useMemo, useState } from "react";
import { RecordPaymentModal } from "./RecordPaymentModal";
import {
  canEditPrepayment,
  mapPrepaymentToRecordPaymentInitialValues,
} from "./prepaymentRecordPaymentHelpers";

const PrepaymentListDrawerContext = createContext(null);

export function PrepaymentListDrawerProvider({ children, onSuccess }) {
  const [prepayment, setPrepayment] = useState(null);

  const openPayment = useCallback(payment => {
    setPrepayment(payment);
  }, []);

  const closePayment = useCallback(() => {
    setPrepayment(null);
  }, []);

  const handleSuccess = useCallback(() => {
    onSuccess?.();
    closePayment();
  }, [closePayment, onSuccess]);

  const value = useMemo(() => ({ openPayment }), [openPayment]);

  const editable = canEditPrepayment(prepayment);
  const initialValues = useMemo(
    () => mapPrepaymentToRecordPaymentInitialValues(prepayment),
    [prepayment],
  );

  return (
    <PrepaymentListDrawerContext.Provider value={value}>
      {children}
      {prepayment ? (
        <RecordPaymentModal
          isOpen
          prepaymentId={prepayment.id}
          readOnly={!editable}
          initialValues={initialValues}
          title={
            editable
              ? `Edit Payment — ${prepayment.name}`
              : `Payment — ${prepayment.name}`
          }
          lockSupplier={Boolean(prepayment.supplier?.id)}
          lockCurrency={Boolean(prepayment.currency?.id)}
          onClose={closePayment}
          onSuccess={handleSuccess}
        />
      ) : null}
    </PrepaymentListDrawerContext.Provider>
  );
}

export function usePrepaymentListDrawer() {
  return useContext(PrepaymentListDrawerContext);
}
